// All answers are real (owner-confirmed 2026-07-09). A few are "draft" wording
// the owner may polish; none assert anything speculative. No COD is offered, so
// COD is not mentioned at all.
export const FAQ_ITEMS = [
  {
    q: "How long does delivery take?",
    a: "We dispatch within 2 working days. Delivery typically takes 5–7 days after dispatch.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept UPI, credit and debit cards, and net banking through a secure payment gateway.",
  },
  {
    q: "What is your return and exchange policy?",
    a: "Damaged or wrong items: tell us within 48 hours of delivery, with photos, and we arrange pickup. Change of mind: return an unused piece with tags attached and in original packaging within 7 days of delivery; the product price is refunded, the shipping charge is not. We do not send replacement parcels, but you can exchange in store within 7 days of delivery with the bill. Online orders can also be cancelled before dispatch for a full refund. See our",
    link: { to: "/policies/returns", label: "Returns & Exchange policy" },
  },
  {
    q: "Why is only one piece available? Can I reorder a sold-out design?",
    a: "Most of our designs are made in very limited numbers, so many are effectively one-of-a-kind. If a design is sold out, message us on WhatsApp and we'll tell you whether a repeat is possible.",
  },
  {
    q: "Can you make an outfit I saw online or at a wedding?",
    a: "Yes. Send us the photo on WhatsApp with your budget and size, and our in-house tailors will quote a price and a ready-by date. We make it as close to the picture as we can, usually in 2 to 4 weeks. See Custom Tailoring for how it works.",
  },
  {
    q: "Do sarees come with a blouse? Is it stitched? Can you alter garments?",
    a: "Where a blouse piece is included it's noted in the product details, and it's supplied unstitched unless stated otherwise. For stitching or alterations, please ask us on WhatsApp.",
  },
  {
    q: "How do I choose the right size?",
    a: "Each product lists its available sizes. If you're unsure, message us on WhatsApp with your measurements and we'll help you pick the right fit.",
  },
  {
    q: "How do I care for silk and embroidered pieces?",
    a: "Silk and embroidered garments are best dry-cleaned. Store them folded in a cool, dry place and keep perfume and deodorant off the fabric. Follow any specific care note on the product.",
  },
  {
    q: "How do I track my order?",
    a: "Once your order ships we'll share tracking details. In the meantime, message us on WhatsApp with your order details for an update.",
  },
  {
    q: "Can I visit your store and buy in person?",
    a: "Yes — visit us at 58 Sihani Gate Market, Near Durga Bhabhi Chowk, Ghaziabad, Uttar Pradesh 201001. You're welcome to browse and buy in person.",
  },
  {
    q: "Are the colours true to the photos?",
    a: "We photograph products as accurately as we can, but screens vary. If the exact shade matters, ask us on WhatsApp for a quick photo or video before you buy.",
  },
  {
    q: "What's the fastest way to reach you?",
    a: "WhatsApp us at +91 98108 73280 — we're happy to answer any question before you buy.",
  },
];
